exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-section[data-v-0b8d288e] {\n  overflow: auto;\n  max-height: 350px;\n}\n.sended-list-table[data-v-0b8d288e] {\n  font-size: 12px;\n  width: 100%;\n  table-layout: fixed;\n}\n.sended-list-table th[data-v-0b8d288e],\n  .sended-list-table td[data-v-0b8d288e] {\n    padding: 8px;\n}\n.sended-list-table .sender[data-v-0b8d288e] {\n    width: 120px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n.sended-list-table .timestamp[data-v-0b8d288e] {\n    width: 160px;\n}\n.empty-tr[data-v-0b8d288e] {\n  height: 36px;\n}\ntd[data-v-0b8d288e] {\n  word-wrap: break-word;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b8d288e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/molecules/tables/LINELogTable.vue
// module id = he4i
// module chunks = 3